import React from "react";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import Perfil2 from "./Perfil2";
import axios from '../../axios/axiosconf';
import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Loading from "./Loading";
import { escalarImagen } from "../../../resources/Helper";
import SignatureCanvas from 'react-signature-canvas';

function Configuracion(props) {

    const [client, setClient] = useState([]);
    const [loggedIn, setLoggedIn] = useState();

    const [showToast, setShowToast] = useState(false);
    const [toastMsg, setToastMsg] = useState('');

    // Estados para encabezado personalizado
    const [encabezado, setEncabezado] = useState({
        nombre_encabezado: '',
        izquierda: '',
        centro: '',
        derecha: '',
        estado: 1
    });
    const [loadingEncabezado, setLoadingEncabezado] = useState(false);
    const [encabezadoExiste, setEncabezadoExiste] = useState(false);

    // Estados para imágenes de cada columna
    const [imagenIzquierda, setImagenIzquierda] = useState('');
    const [imagenCentro, setImagenCentro] = useState('');
    const [imagenDerecha, setImagenDerecha] = useState('');

    // Estados para tamaños de imagen personalizados
    const [tamañoImagenIzquierda, setTamañoImagenIzquierda] = useState('normal');
    const [tamañoImagenCentro, setTamañoImagenCentro] = useState('normal');
    const [tamañoImagenDerecha, setTamañoImagenDerecha] = useState('normal');

    // Estados para editores de texto simples
    const [contenidoIzquierda, setContenidoIzquierda] = useState('');
    const [contenidoCentro, setContenidoCentro] = useState('');
    const [contenidoDerecha, setContenidoDerecha] = useState('');

    // Referencias para los editores de texto
    const editorIzquierdaRef = useRef(null);
    const editorCentroRef = useRef(null);
    const editorDerechaRef = useRef(null);

    // Referencias para canvas de cada columna
    const canvasIzquierdaRef = useRef(null);
    const canvasCentroRef = useRef(null);
    const canvasDerechaRef = useRef(null);

    // Estado para controlar si los editores están listos
    const [editoresReady, setEditoresReady] = useState(false);

    // Estado para controlar la pestaña activa
    const [activeTab, setActiveTab] = useState('perfil');

    // ── Estados para la pestaña "Firma" ──
    const [firmaBlob, setFirmaBlob] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');
    const [modoFirma, setModoFirma] = useState('dibujar'); // 'dibujar' | 'imagen'
    const [loadingFirma, setLoadingFirma] = useState(false);
    const [firmaGuardadaMsg, setFirmaGuardadaMsg] = useState('');
    const [firmaCargada, setFirmaCargada] = useState(false);
    const firmaCanvasRef = useRef(null);
    const firmaFileInputRef = useRef(null);

    let userdata = [];
    let clientData = [];



    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setLoggedIn(true);
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        // ── Cargar datos de firma del usuario ──
        axios.get('/perfil?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    if (response.data.firma_blob) {
                        setFirmaBlob(response.data.firma_blob);
                    }
                    if (response.data.texto_pie_firma) {
                        setTextoPieFirma(response.data.texto_pie_firma);
                    }
                    setFirmaCargada(true);
                }
            })
            .catch(error => {
                console.log('Error cargando firma:', error);
                setFirmaCargada(true);
            });

        // Cargar encabezado personalizado si existe
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data) {
                    const encabezadoData = {
                        nombre_encabezado: response.data.nombre_encabezado || '',
                        izquierda: response.data.izquierda || '',
                        centro: response.data.centro || '',
                        derecha: response.data.derecha || '',
                        estado: response.data.estado || 1
                    };
                    setEncabezado(encabezadoData);
                    setEncabezadoExiste(true);

                    // Actualizar contenido de editores
                    setContenidoIzquierda(encabezadoData.izquierda);
                    setContenidoCentro(encabezadoData.centro);
                    setContenidoDerecha(encabezadoData.derecha);
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    console.log('No hay encabezado personalizado configurado - inicializando formulario vacío');
                } else {
                    console.log('Error Al Cargar Encabezado Personalizado:', error);
                }
                // Siempre inicializar con valores vacíos para mostrar el formulario
                setEncabezado({
                    nombre_encabezado: '',
                    izquierda: '',
                    centro: '',
                    derecha: '',
                    estado: 1
                });
                setEncabezadoExiste(false);
            });

        // Marcar editores como listos después de un pequeño delay
        setTimeout(() => {
            setEditoresReady(true);
        }, 500);
    }, []);

    const handleSubmitEncabezado = (e) => {
        e.preventDefault();
        setLoadingEncabezado(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        };

        // get-client devuelve client_id (no id). Si el estado aún no cargó, usar client_id del login.
        const rawClient =
            client?.client_id ?? client?.id ?? userdata?.client_id;
        const clientId = rawClient != null && rawClient !== ''
            ? parseInt(rawClient, 10)
            : NaN;

        const data = {
            uid: userdata.user_id,
            client_id: clientId,
            ...encabezado
        };

        if (!Number.isFinite(clientId) || clientId < 1) {
            setLoadingEncabezado(false);
            setToastMsg('No se pudo obtener el cliente. Espere a que carguen los datos o recargue la página.');
            setShowToast(true);
            return;
        }

        // Validación antes de enviar
        if (!data.nombre_encabezado || data.nombre_encabezado.trim() === '') {
            setLoadingEncabezado(false);
            setToastMsg('El Nombre Del Encabezado Es Requerido');
            setShowToast(true);
            return;
        }

        const url = encabezadoExiste ? '/encabezado-personalizado' : '/encabezado-personalizado';
        const method = encabezadoExiste ? 'put' : 'post';

        axios[method](url, data, config)
            .then(response => {
                setLoadingEncabezado(false);
                if (response.status === 200 || response.status === 201) {
                    setShowToast(true);
                    setToastMsg('Encabezado Personalizado Guardado Exitosamente');
                    setEncabezadoExiste(true);
                }
            })
            .catch(err => {
                console.log('❌ Error completo:', err);
                console.log('❌ Error response:', err.response);
                if (err.response && err.response.data) {
                    console.log('❌ Error data:', err.response.data);
                    if (err.response.data.errors) {
                        // Mostrar errores de validación específicos
                        const errores = Object.values(err.response.data.errors).flat().join(', ');
                        setToastMsg('Errores de validación: ' + errores);
                    } else {
                        const apiMsg = err.response.data.message || err.response.data.error;
                        setToastMsg(
                            apiMsg
                                ? String(apiMsg)
                                : 'Error Al Guardar El Encabezado Personalizado'
                        );
                    }
                } else {
                    setToastMsg('Error Al Guardar El Encabezado Personalizado');
                }
                setLoadingEncabezado(false);
                setShowToast(true);
            });
    };

    const handleEncabezadoChange = (field, value) => {
        setEncabezado(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Funciones para aplicar colores al texto seleccionado - VERSIÓN SIMPLE QUE FUNCIONA
    const aplicarColor = (columna, color) => {
        let editorRef = null;
        if (columna === 'izquierda') {
            editorRef = editorIzquierdaRef.current;
        } else if (columna === 'centro') {
            editorRef = editorCentroRef.current;
        } else if (columna === 'derecha') {
            editorRef = editorDerechaRef.current;
        }

        if (editorRef) {
            editorRef.focus();

            // Obtener texto seleccionado
            const selection = window.getSelection();
            const selectedText = selection.toString();

            if (selectedText && selectedText.length > 0) {
                // Hay texto seleccionado - aplicar color
                document.execCommand('foreColor', false, color);
            } else {
                // No hay selección - insertar texto con color
                const textoColoreado = `<span style="color: ${color};">Texto con color</span>&nbsp;`;
                document.execCommand('insertHTML', false, textoColoreado);
            }

            // Actualizar el estado
            const nuevoContenido = editorRef.innerHTML;
            handleEncabezadoChange(columna, nuevoContenido);
        }
    };

    // Funciones para aplicar formato de texto
    const aplicarFormato = (columna, comando) => {
        let editorRef = null;
        if (columna === 'izquierda') {
            editorRef = editorIzquierdaRef.current;
        } else if (columna === 'centro') {
            editorRef = editorCentroRef.current;
        } else if (columna === 'derecha') {
            editorRef = editorDerechaRef.current;
        }

        if (editorRef) {
            editorRef.focus();
            document.execCommand(comando, false, null);

            // Actualizar el estado
            const nuevoContenido = editorRef.innerHTML;
            handleEncabezadoChange(columna, nuevoContenido);
        }
    };

    // Handlers para cambios en los editores
    const handleContenidoChange = (columna, contenido) => {
        if (columna === 'izquierda') {
            setContenidoIzquierda(contenido);
        } else if (columna === 'centro') {
            setContenidoCentro(contenido);
        } else if (columna === 'derecha') {
            setContenidoDerecha(contenido);
        }
        handleEncabezadoChange(columna, contenido);
    };

    // Sincronizar contenido de editores manualmente para evitar salto de cursor
    useEffect(() => {
        if (editorIzquierdaRef.current && (editorIzquierdaRef.current.innerHTML !== contenidoIzquierda)) {
            // Solo actualizar si es diferente para evitar saltos, pero si está vacío y hay contenido, forzarlo
            if (contenidoIzquierda && editorIzquierdaRef.current.innerHTML === '') {
                editorIzquierdaRef.current.innerHTML = contenidoIzquierda;
            } else if (editorIzquierdaRef.current.innerHTML !== contenidoIzquierda) {
                editorIzquierdaRef.current.innerHTML = contenidoIzquierda;
            }
        }
    }, [contenidoIzquierda, editoresReady, activeTab]);

    useEffect(() => {
        if (editorCentroRef.current && (editorCentroRef.current.innerHTML !== contenidoCentro)) {
            if (contenidoCentro && editorCentroRef.current.innerHTML === '') {
                editorCentroRef.current.innerHTML = contenidoCentro;
            } else if (editorCentroRef.current.innerHTML !== contenidoCentro) {
                editorCentroRef.current.innerHTML = contenidoCentro;
            }
        }
    }, [contenidoCentro, editoresReady, activeTab]);

    useEffect(() => {
        if (editorDerechaRef.current && (editorDerechaRef.current.innerHTML !== contenidoDerecha)) {
            if (contenidoDerecha && editorDerechaRef.current.innerHTML === '') {
                editorDerechaRef.current.innerHTML = contenidoDerecha;
            } else if (editorDerechaRef.current.innerHTML !== contenidoDerecha) {
                editorDerechaRef.current.innerHTML = contenidoDerecha;
            }
        }
    }, [contenidoDerecha, editoresReady, activeTab]);

    // Funciones para manejar imágenes (insertar en editores simples)
    const agregarImagenIzquierda = (files) => {
        if (files && files[0]) {
            procesarImagen(files[0], canvasIzquierdaRef, 'izquierda');
        }
    };

    const agregarImagenCentro = (files) => {
        if (files && files[0]) {
            procesarImagen(files[0], canvasCentroRef, 'centro');
        }
    };

    const agregarImagenDerecha = (files) => {
        if (files && files[0]) {
            procesarImagen(files[0], canvasDerechaRef, 'derecha');
        }
    };

    const procesarImagen = (file, canvasRef, columna) => {
        const f = URL.createObjectURL(file);
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        const img = new Image();

        img.onload = function () {
            // Obtener tamaño seleccionado por el usuario
            let tamañoSeleccionado = 'normal';
            if (columna === 'izquierda') {
                tamañoSeleccionado = tamañoImagenIzquierda;
            } else if (columna === 'centro') {
                tamañoSeleccionado = tamañoImagenCentro;
            } else if (columna === 'derecha') {
                tamañoSeleccionado = tamañoImagenDerecha;
            }

            // Definir tamaños según la selección del usuario
            let maxWidth, maxHeight;

            switch (tamañoSeleccionado) {
                case 'pequeño':
                    maxWidth = columna === 'centro' ? 120 : 100;
                    maxHeight = columna === 'centro' ? 60 : 50;
                    break;
                case 'normal':
                    maxWidth = columna === 'centro' ? 180 : 150;
                    maxHeight = columna === 'centro' ? 90 : 80;
                    break;
                case 'grande':
                    maxWidth = columna === 'centro' ? 240 : 200;
                    maxHeight = columna === 'centro' ? 120 : 100;
                    break;
                default:
                    maxWidth = columna === 'centro' ? 180 : 150;
                    maxHeight = columna === 'centro' ? 90 : 80;
            }

            // Escalar imagen manteniendo proporciones para que se vea completa
            const imagenEscalada = escalarImagen(img.width, img.height, maxWidth, maxHeight);

            // Ajustar canvas al tamaño de la imagen escalada para evitar cortes
            canvasRef.current.width = imagenEscalada.ancho;
            canvasRef.current.height = imagenEscalada.alto;

            // Dibujar imagen completa sin recortes con alta calidad
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(img, 0, 0, imagenEscalada.ancho, imagenEscalada.alto);

            const imagenBase64 = canvasRef.current.toDataURL();

            // Generar HTML para la imagen
            const htmlImagen = `<img src="${imagenBase64}" style="max-width: ${maxWidth}px; max-height: ${maxHeight}px; width: auto; height: auto; display: inline-block; vertical-align: middle; object-fit: contain;" alt="Imagen ${columna} (${tamañoSeleccionado})" />`;

            // Insertar imagen en el editor
            let editorRef = null;
            if (columna === 'izquierda') {
                editorRef = editorIzquierdaRef.current;
            } else if (columna === 'centro') {
                editorRef = editorCentroRef.current;
            } else if (columna === 'derecha') {
                editorRef = editorDerechaRef.current;
            }

            if (editorRef) {
                editorRef.focus();
                document.execCommand('insertHTML', false, htmlImagen);

                // Actualizar el estado
                const nuevoContenido = editorRef.innerHTML;
                handleEncabezadoChange(columna, nuevoContenido);
            }

            // Restaurar tamaño original del canvas
            canvasRef.current.width = 200;
            canvasRef.current.height = 100;
        };

        img.src = f;
    };

    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Aquí puedes implementar la subida del archivo
            // Por ahora, simularemos con una URL
            const reader = new FileReader();
            reader.onload = (event) => {
                handleEncabezadoChange('logo_url', event.target.result);
            };
            reader.readAsDataURL(file);
        }
    };


    const handleToastMsg = (msg) => {
        setShowToast(true);

        setTimeout(() => { setShowToast(false); }, 3000);
    }

    // ── Funciones de la pestaña Firma ──

    /** Cargar firma dibujada en canvas cuando se activa la pestaña */
    useEffect(() => {
        if (activeTab === 'firma' && modoFirma === 'dibujar' && firmaBlob && firmaCanvasRef.current) {
            setTimeout(() => {
                try {
                    firmaCanvasRef.current.fromDataURL(firmaBlob);
                } catch (e) {
                    console.warn('No se pudo cargar firma en canvas:', e);
                }
            }, 100);
        }
    }, [activeTab, modoFirma, firmaCargada]);

    /** Subir imagen de firma: validar formato, redimensionar y comprimir a base64 */
    const handleSubirImagenFirma = (files) => {
        if (!files || files.length === 0) return;
        const file = files[0];

        // Validar tipo de archivo
        const tiposPermitidos = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!tiposPermitidos.includes(file.type)) {
            alert('Solo se permiten archivos PNG o JPG');
            return;
        }

        // Validar tamaño original (máx 5MB antes de comprimir)
        if (file.size > 5 * 1024 * 1024) {
            alert('La imagen no debe superar los 5MB');
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                // Dimensiones máximas para una firma (no necesita más)
                const MAX_ANCHO = 400;
                const MAX_ALTO = 200;

                let nuevoAncho = img.width;
                let nuevoAlto = img.height;

                // Redimensionar manteniendo proporción
                if (nuevoAncho > MAX_ANCHO || nuevoAlto > MAX_ALTO) {
                    const ratioAncho = MAX_ANCHO / nuevoAncho;
                    const ratioAlto = MAX_ALTO / nuevoAlto;
                    const ratio = Math.min(ratioAncho, ratioAlto);
                    nuevoAncho = Math.round(nuevoAncho * ratio);
                    nuevoAlto = Math.round(nuevoAlto * ratio);
                }

                // Crear canvas temporal para redimensionar y comprimir
                const canvas = document.createElement('canvas');
                canvas.width = nuevoAncho;
                canvas.height = nuevoAlto;
                const ctx = canvas.getContext('2d');

                // Fondo blanco (para JPEGs con transparencia)
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, nuevoAncho, nuevoAlto);
                ctx.drawImage(img, 0, 0, nuevoAncho, nuevoAlto);

                // Exportar: PNG si era PNG (preserva transparencia), sino JPEG comprimido
                let base64;
                if (file.type === 'image/png') {
                    base64 = canvas.toDataURL('image/png');
                } else {
                    base64 = canvas.toDataURL('image/jpeg', 0.85);
                }

                console.log(`Firma: ${img.width}x${img.height} → ${nuevoAncho}x${nuevoAlto} | ${(base64.length / 1024).toFixed(1)}KB base64`);
                setFirmaBlob(base64);
            };
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    };

    /** Guardar firma y texto pie de firma via PUT /perfil */
    const handleGuardarFirma = () => {
        let userData = {};
        if (localStorage.getItem('userdata')) {
            userData = JSON.parse(localStorage.getItem('userdata'));
        }

        setLoadingFirma(true);
        setFirmaGuardadaMsg('');

        // Obtener firma base64
        let firmaBase64 = null;
        if (modoFirma === 'dibujar') {
            const canvas = firmaCanvasRef.current;
            if (canvas && !canvas.isEmpty()) {
                firmaBase64 = canvas.toDataURL('image/png');
            }
        } else {
            // Modo imagen: firmaBlob ya es base64
            firmaBase64 = firmaBlob || null;
        }

        const payload = {
            uid: userData.user_id,
            firma_blob: firmaBase64,
            texto_pie_firma: textoPieFirma || null
        };

        axios.put('/perfil', payload)
            .then(response => {
                setLoadingFirma(false);
                setFirmaBlob(firmaBase64);
                setFirmaGuardadaMsg('Firma guardada correctamente');

                // Actualizar localStorage
                userData.firma = !!firmaBase64;
                localStorage.setItem('userdata', JSON.stringify(userData));

                // Toast
                setToastMsg('Firma actualizada correctamente');
                setShowToast(true);
                setTimeout(() => { setShowToast(false); }, 3000);
                setTimeout(() => { setFirmaGuardadaMsg(''); }, 4000);
            })
            .catch(error => {
                setLoadingFirma(false);
                console.log('Error guardando firma:', error);
                setFirmaGuardadaMsg('Error al guardar la firma');
            });
    };

    /** Limpiar canvas de firma */
    const handleLimpiarFirmaCanvas = () => {
        if (firmaCanvasRef.current) {
            firmaCanvasRef.current.clear();
        }
    };


    if (loggedIn) {
        return (
            <>
                {/* Estilos CSS para Editores Simples */}
                <style jsx>{`
                    .editor-simple-container {
                        border: 1px solid #ced4da;
                        border-radius: 0.25rem;
                        background: white;
                    }
                    
                    .editor-toolbar {
                        padding: 8px;
                        border-bottom: 1px solid #e9ecef;
                        background: #f8f9fa;
                        border-radius: 0.25rem 0.25rem 0 0;
                    }
                    
                    .editor-content {
                        border: none !important;
                        outline: none !important;
                        box-shadow: none !important;
                        resize: vertical;
                        line-height: 1.4;
                    }
                    
                    .editor-content:focus {
                        border: none !important;
                        box-shadow: none !important;
                    }
                    
                    .editor-content p {
                        margin: 0 0 8px 0;
                        line-height: 1.4;
                    }
                    
                    .editor-content p:last-child {
                        margin-bottom: 0;
                    }
                    
                    .editor-content ul, 
                    .editor-content ol {
                        margin: 0 0 8px 20px;
                        padding: 0;
                    }
                    
                    .editor-content li {
                        margin: 2px 0;
                    }
                    
                    .editor-content img {
                        max-width: 100%;
                        height: auto;
                        display: inline-block;
                        vertical-align: middle;
                        object-fit: contain;
                    }
                    
                    .editor-content[contenteditable]:empty:before {
                        content: attr(placeholder);
                        color: #6c757d;
                        font-style: italic;
                    }
                    
                    /* Estilos responsivos para móvil */
                    @media (max-width: 768px) {
                        .encabezado-columns-container {
                            overflow-x: auto;
                            -webkit-overflow-scrolling: touch;
                            padding-bottom: 10px;
                        }
                        
                        .encabezado-columns-container .row {
                            min-width: 900px; /* Ancho mínimo para 3 columnas */
                            flex-wrap: nowrap !important;
                        }
                        
                        .encabezado-columns-container .col-md-4 {
                            flex: 0 0 280px !important;
                            min-width: 280px !important;
                            max-width: 280px !important;
                        }
                        
                        .editor-content {
                            min-height: 100px !important;
                        }
                        
                        .editor-toolbar {
                            padding: 6px;
                        }
                        
                        .btn-group-sm .btn {
                            padding: 0.25rem 0.4rem;
                            font-size: 0.75rem;
                        }
                        
                        .color-buttons-container {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 3px;
                        }
                        
                        .color-button {
                            width: 20px !important;
                            height: 20px !important;
                            min-width: 20px !important;
                            padding: 0 !important;
                            margin: 0 !important;
                        }
                    }
                    
                    @media (max-width: 576px) {
                        .encabezado-columns-container .row {
                            min-width: 800px;
                            flex-wrap: nowrap !important;
                        }
                        
                        .encabezado-columns-container .col-md-4 {
                            flex: 0 0 250px !important;
                            min-width: 250px !important;
                            max-width: 250px !important;
                        }
                        
                        .editor-content {
                            min-height: 80px !important;
                            font-size: 14px;
                        }
                    }
                `}</style>

                <div className="hold-transition">
                    <Header client={client} />
                    <Aside client={client} activelink="profile" />

                    <div className="content-wrapper">
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-8">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item" key="k0"><Link to="/home">Home</Link></li>
                                            <li className="breadcrumb-item" key="k1">Opciones Personales</li>
                                        </ol>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-sm-8">
                                        <h1 className="m-0">Opciones Personales</h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section className="content" >
                            <div className="container-fluid">

                                <div className="row">
                                    <div className="col-md-12">

                                        <style>{`
                                            .config-personal-tabs.nav-pills {
                                                gap: 8px;
                                                flex-wrap: wrap;
                                                border-bottom: none;
                                            }
                                            .config-personal-tabs .nav-item { margin-bottom: 0; }
                                            .config-personal-tabs .nav-link {
                                                cursor: pointer;
                                                border: 1px solid #e8ecef !important;
                                                border-radius: 10px !important;
                                                color: #495057 !important;
                                                background-color: #f8f9fa !important;
                                                padding: 10px 18px !important;
                                                font-weight: 600;
                                                font-size: 0.9375rem;
                                                margin-right: 0 !important;
                                                box-shadow: none !important;
                                                transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
                                            }
                                            .config-personal-tabs .nav-link:hover,
                                            .config-personal-tabs .nav-link:focus-visible {
                                                color: #117a8b !important;
                                                background-color: #f1f5f9 !important;
                                                border-color: #dee2e6 !important;
                                            }
                                            .config-personal-tabs .nav-link.active {
                                                color: #0d5c6b !important;
                                                background-color: #fff !important;
                                                border-color: #17a2b8 !important;
                                                box-shadow: 0 0 0 1px rgba(23, 162, 184, 0.35) !important;
                                            }
                                            .config-personal-tabs .nav-link.active:hover,
                                            .config-personal-tabs .nav-link.active:focus-visible {
                                                color: #0d5c6b !important;
                                                background-color: #fff !important;
                                            }
                                            .config-personal-card {
                                                border-radius: 12px;
                                                border: 1px solid #eef0f2 !important;
                                            }
                                            .config-personal-card > .card-header {
                                                background: #fafbfc;
                                                border-bottom: 1px solid #eef0f2;
                                                border-radius: 12px 12px 0 0 !important;
                                                padding: 12px 14px !important;
                                            }
                                            .config-personal-card > .card-body {
                                                padding-top: 1.25rem;
                                            }
                                        `}</style>

                                        <div className="card shadow-sm config-personal-card border-0">
                                            <div className="card-header p-2">
                                                <ul className="nav nav-pills nav-pills-configuracion config-personal-tabs">
                                                    <li className="nav-item" key={'tab1'}>
                                                        <button
                                                            className={`nav-link ${activeTab === 'perfil' ? 'active' : ''}`}
                                                            onClick={() => setActiveTab('perfil')}
                                                            type="button"
                                                        >
                                                            Mi perfil
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" key={'tab2'}>
                                                        <button
                                                            className={`nav-link ${activeTab === 'firma' ? 'active' : ''}`}
                                                            onClick={() => setActiveTab('firma')}
                                                            type="button"
                                                        >
                                                            <i className="fas fa-signature mr-1"></i>
                                                            Firma
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" key={'tab3'}>
                                                        <button
                                                            className={`nav-link ${activeTab === 'encabezado' ? 'active' : ''}`}
                                                            onClick={() => setActiveTab('encabezado')}
                                                            type="button"
                                                        >
                                                            Encabezado
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="card-body">
                                                <div className="tab-content">
                                                    {activeTab === 'encabezado' && (
                                                        <div className="tab-pane active">
                                                            <form onSubmit={handleSubmitEncabezado}>
                                                                <div className="row">
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>Nombre del Encabezado *</label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={encabezado?.nombre_encabezado || ''}
                                                                                onChange={(e) => handleEncabezadoChange('nombre_encabezado', e.target.value)}
                                                                                placeholder="Ej: Encabezado Clínica Principal"
                                                                                required
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="form-group">
                                                                            <label>Estado</label>
                                                                            <select
                                                                                className="form-control"
                                                                                value={encabezado?.estado || 1}
                                                                                onChange={(e) => handleEncabezadoChange('estado', parseInt(e.target.value))}
                                                                            >
                                                                                <option value={1}>Habilitado</option>
                                                                                <option value={0}>Deshabilitado</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="encabezado-columns-container">
                                                                    <div className="row">
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <i className="fas fa-align-left mr-1"></i>
                                                                                    Columna Izquierda (30%)
                                                                                </label>

                                                                                {/* Editor Simple - Columna Izquierda */}
                                                                                {editoresReady ? (
                                                                                    <div className="editor-simple-container">
                                                                                        <div className="editor-toolbar mb-2">
                                                                                            <div className="btn-group btn-group-sm" role="group">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('izquierda', 'bold')}
                                                                                                    title="Negrita"
                                                                                                >
                                                                                                    <i className="fas fa-bold"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('izquierda', 'italic')}
                                                                                                    title="Cursiva"
                                                                                                >
                                                                                                    <i className="fas fa-italic"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('izquierda', 'underline')}
                                                                                                    title="Subrayado"
                                                                                                >
                                                                                                    <i className="fas fa-underline"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('izquierda', 'insertUnorderedList')}
                                                                                                    title="Lista"
                                                                                                >
                                                                                                    <i className="fas fa-list-ul"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            ref={editorIzquierdaRef}
                                                                                            className="editor-content form-control"
                                                                                            contentEditable={true}
                                                                                            style={{ minHeight: '120px', padding: '10px' }}
                                                                                            suppressContentEditableWarning={true}
                                                                                            onInput={(e) => handleContenidoChange('izquierda', e.target.innerHTML)}
                                                                                            placeholder="Escribe el contenido para la columna izquierda..."
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="alert alert-info">
                                                                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                                                                        Cargando editor...
                                                                                    </div>
                                                                                )}

                                                                                {/* Canvas oculto para procesar imagen */}
                                                                                <canvas
                                                                                    ref={canvasIzquierdaRef}
                                                                                    width="200"
                                                                                    height="100"
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Input file oculto */}
                                                                                <input
                                                                                    type="file"
                                                                                    id="imagenIzquierda"
                                                                                    accept=".jpg,.png,.jpeg"
                                                                                    onChange={(e) => agregarImagenIzquierda(e.target.files)}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Selector de tamaño de imagen */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-expand-arrows-alt mr-1"></i>
                                                                                        Tamaño de imagen:
                                                                                    </small>
                                                                                    <select
                                                                                        className="form-control form-control-sm"
                                                                                        value={tamañoImagenIzquierda}
                                                                                        onChange={(e) => setTamañoImagenIzquierda(e.target.value)}
                                                                                    >
                                                                                        <option value="pequeño">Pequeño (100x50px)</option>
                                                                                        <option value="normal">Normal (150x80px)</option>
                                                                                        <option value="grande">Grande (200x100px)</option>
                                                                                    </select>
                                                                                </div>

                                                                                {/* Botón para cargar imagen */}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-success btn-sm mt-2 w-100"
                                                                                    onClick={() => document.getElementById('imagenIzquierda').click()}
                                                                                >
                                                                                    <i className="fas fa-image mr-2"></i>
                                                                                    Insertar Imagen ({tamañoImagenIzquierda})
                                                                                </button>

                                                                                {/* Botones de colores */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-palette mr-1"></i>
                                                                                        Colores de texto:
                                                                                    </small>
                                                                                    <div className="color-buttons-container">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#000000', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#000000')}
                                                                                            title="Negro"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#dc3545', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#dc3545')}
                                                                                            title="Rojo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#007bff', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#007bff')}
                                                                                            title="Azul"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#28a745', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#28a745')}
                                                                                            title="Verde"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#ffc107', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#ffc107')}
                                                                                            title="Amarillo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#6f42c1', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('izquierda', '#6f42c1')}
                                                                                            title="Morado"
                                                                                        ></button>
                                                                                    </div>
                                                                                </div>

                                                                                <small className="form-text text-muted mt-2">
                                                                                    <i className="fas fa-info-circle mr-1"></i>
                                                                                    <strong>Colores:</strong> Selecciona texto y haz clic en un color - ¡funciona con document.execCommand!
                                                                                    <br />
                                                                                    <strong>Imágenes:</strong> Elige el tamaño y haz clic en "Insertar Imagen".
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <i className="fas fa-align-center mr-1"></i>
                                                                                    Columna Centro (40%)
                                                                                </label>

                                                                                {/* Editor Simple - Columna Centro */}
                                                                                {editoresReady ? (
                                                                                    <div className="editor-simple-container">
                                                                                        <div className="editor-toolbar mb-2">
                                                                                            <div className="btn-group btn-group-sm" role="group">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('centro', 'bold')}
                                                                                                    title="Negrita"
                                                                                                >
                                                                                                    <i className="fas fa-bold"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('centro', 'italic')}
                                                                                                    title="Cursiva"
                                                                                                >
                                                                                                    <i className="fas fa-italic"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('centro', 'underline')}
                                                                                                    title="Subrayado"
                                                                                                >
                                                                                                    <i className="fas fa-underline"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('centro', 'insertUnorderedList')}
                                                                                                    title="Lista"
                                                                                                >
                                                                                                    <i className="fas fa-list-ul"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            ref={editorCentroRef}
                                                                                            className="editor-content form-control"
                                                                                            contentEditable={true}
                                                                                            style={{ minHeight: '120px', padding: '10px' }}
                                                                                            suppressContentEditableWarning={true}
                                                                                            onInput={(e) => handleContenidoChange('centro', e.target.innerHTML)}
                                                                                            placeholder="Escribe el contenido para la columna centro..."
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="alert alert-info">
                                                                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                                                                        Cargando editor...
                                                                                    </div>
                                                                                )}

                                                                                {/* Canvas oculto para procesar imagen */}
                                                                                <canvas
                                                                                    ref={canvasCentroRef}
                                                                                    width="200"
                                                                                    height="100"
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Input file oculto */}
                                                                                <input
                                                                                    type="file"
                                                                                    id="imagenCentro"
                                                                                    accept=".jpg,.png,.jpeg"
                                                                                    onChange={(e) => agregarImagenCentro(e.target.files)}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Selector de tamaño de imagen */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-expand-arrows-alt mr-1"></i>
                                                                                        Tamaño de imagen:
                                                                                    </small>
                                                                                    <select
                                                                                        className="form-control form-control-sm"
                                                                                        value={tamañoImagenCentro}
                                                                                        onChange={(e) => setTamañoImagenCentro(e.target.value)}
                                                                                    >
                                                                                        <option value="pequeño">Pequeño (120x60px)</option>
                                                                                        <option value="normal">Normal (180x90px)</option>
                                                                                        <option value="grande">Grande (240x120px)</option>
                                                                                    </select>
                                                                                </div>

                                                                                {/* Botón para cargar imagen */}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-success btn-sm mt-2 w-100"
                                                                                    onClick={() => document.getElementById('imagenCentro').click()}
                                                                                >
                                                                                    <i className="fas fa-image mr-2"></i>
                                                                                    Insertar Imagen ({tamañoImagenCentro})
                                                                                </button>

                                                                                {/* Botones de colores */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-palette mr-1"></i>
                                                                                        Colores de texto:
                                                                                    </small>
                                                                                    <div className="color-buttons-container">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#000000', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#000000')}
                                                                                            title="Negro"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#dc3545', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#dc3545')}
                                                                                            title="Rojo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#007bff', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#007bff')}
                                                                                            title="Azul"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#28a745', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#28a745')}
                                                                                            title="Verde"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#ffc107', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#ffc107')}
                                                                                            title="Amarillo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm color-button"
                                                                                            style={{ backgroundColor: '#6f42c1', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('centro', '#6f42c1')}
                                                                                            title="Morado"
                                                                                        ></button>
                                                                                    </div>
                                                                                </div>

                                                                                <small className="form-text text-muted mt-2">
                                                                                    <i className="fas fa-hospital mr-1"></i>
                                                                                    Información principal de la clínica con formato profesional.
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-4">
                                                                            <div className="form-group">
                                                                                <label>
                                                                                    <i className="fas fa-align-right mr-1"></i>
                                                                                    Columna Derecha (30%)
                                                                                </label>

                                                                                {/* Editor Simple - Columna Derecha */}
                                                                                {editoresReady ? (
                                                                                    <div className="editor-simple-container">
                                                                                        <div className="editor-toolbar mb-2">
                                                                                            <div className="btn-group btn-group-sm" role="group">
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('derecha', 'bold')}
                                                                                                    title="Negrita"
                                                                                                >
                                                                                                    <i className="fas fa-bold"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('derecha', 'italic')}
                                                                                                    title="Cursiva"
                                                                                                >
                                                                                                    <i className="fas fa-italic"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('derecha', 'underline')}
                                                                                                    title="Subrayado"
                                                                                                >
                                                                                                    <i className="fas fa-underline"></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-secondary"
                                                                                                    onClick={() => aplicarFormato('derecha', 'insertUnorderedList')}
                                                                                                    title="Lista"
                                                                                                >
                                                                                                    <i className="fas fa-list-ul"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            ref={editorDerechaRef}
                                                                                            className="editor-content form-control"
                                                                                            contentEditable={true}
                                                                                            style={{ minHeight: '120px', padding: '10px' }}
                                                                                            suppressContentEditableWarning={true}
                                                                                            onInput={(e) => handleContenidoChange('derecha', e.target.innerHTML)}
                                                                                            placeholder="Escribe el contenido para la columna derecha..."
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="alert alert-info">
                                                                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                                                                        Cargando editor...
                                                                                    </div>
                                                                                )}

                                                                                {/* Canvas oculto para procesar imagen */}
                                                                                <canvas
                                                                                    ref={canvasDerechaRef}
                                                                                    width="200"
                                                                                    height="100"
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Input file oculto */}
                                                                                <input
                                                                                    type="file"
                                                                                    id="imagenDerecha"
                                                                                    accept=".jpg,.png,.jpeg"
                                                                                    onChange={(e) => agregarImagenDerecha(e.target.files)}
                                                                                    style={{ display: 'none' }}
                                                                                />

                                                                                {/* Selector de tamaño de imagen */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-expand-arrows-alt mr-1"></i>
                                                                                        Tamaño de imagen:
                                                                                    </small>
                                                                                    <select
                                                                                        className="form-control form-control-sm"
                                                                                        value={tamañoImagenDerecha}
                                                                                        onChange={(e) => setTamañoImagenDerecha(e.target.value)}
                                                                                    >
                                                                                        <option value="pequeño">Pequeño (100x50px)</option>
                                                                                        <option value="normal">Normal (150x80px)</option>
                                                                                        <option value="grande">Grande (200x100px)</option>
                                                                                    </select>
                                                                                </div>

                                                                                {/* Botón para cargar imagen */}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-success btn-sm mt-2 w-100"
                                                                                    onClick={() => document.getElementById('imagenDerecha').click()}
                                                                                >
                                                                                    <i className="fas fa-image mr-2"></i>
                                                                                    Insertar Imagen ({tamañoImagenDerecha})
                                                                                </button>

                                                                                {/* Botones de colores */}
                                                                                <div className="mt-2">
                                                                                    <small className="text-muted d-block mb-1">
                                                                                        <i className="fas fa-palette mr-1"></i>
                                                                                        Colores de texto:
                                                                                    </small>
                                                                                    <div className="d-flex flex-wrap">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#000000', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#000000')}
                                                                                            title="Negro"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#dc3545', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#dc3545')}
                                                                                            title="Rojo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#007bff', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#007bff')}
                                                                                            title="Azul"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#28a745', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#28a745')}
                                                                                            title="Verde"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#ffc107', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#ffc107')}
                                                                                            title="Amarillo"
                                                                                        ></button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-sm mr-1 mb-1"
                                                                                            style={{ backgroundColor: '#6f42c1', width: '25px', height: '25px', padding: '0' }}
                                                                                            onClick={() => aplicarColor('derecha', '#6f42c1')}
                                                                                            title="Morado"
                                                                                        ></button>
                                                                                    </div>
                                                                                </div>

                                                                                <small className="form-text text-muted mt-2">
                                                                                    <i className="fas fa-receipt mr-1"></i>
                                                                                    Datos adicionales, fechas, números de factura.
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Vista previa del encabezado */}
                                                                {(encabezado?.nombre_encabezado || encabezado?.izquierda || encabezado?.centro || encabezado?.derecha) && (
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <div className="card card-outline card-info">
                                                                                <div className="card-header">
                                                                                    <h3 className="card-title">
                                                                                        <i className="fas fa-eye mr-2"></i>Vista Previa del Encabezado (tamaño real de impresión)
                                                                                    </h3>
                                                                                </div>
                                                                                <div className="card-body" style={{ backgroundColor: '#e9ecef', padding: '15px' }}>
                                                                                    {/* Contenedor que simula el ancho real del documento impreso */}
                                                                                    <div style={{
                                                                                        maxWidth: '680px',
                                                                                        margin: '0 auto',
                                                                                        backgroundColor: '#ffffff',
                                                                                        padding: '10px',
                                                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                                        border: '1px solid #dee2e6'
                                                                                    }}>
                                                                                        <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#ffffff' }}>
                                                                                            <tbody>
                                                                                                <tr>
                                                                                                    {/* Columna Izquierda - 30% */}
                                                                                                    <td style={{
                                                                                                        width: '30%',
                                                                                                        padding: '2px',
                                                                                                        fontSize: '10px',
                                                                                                        lineHeight: '1.1',
                                                                                                        verticalAlign: 'top',
                                                                                                        wordWrap: 'break-word'
                                                                                                    }}
                                                                                                    dangerouslySetInnerHTML={{
                                                                                                        __html: encabezado?.izquierda || '<em style="color:#999">Columna izquierda vacía</em>'
                                                                                                    }} />

                                                                                                    {/* Columna Centro - 40% */}
                                                                                                    <td style={{
                                                                                                        width: '40%',
                                                                                                        padding: '2px',
                                                                                                        textAlign: 'center',
                                                                                                        fontSize: '11px',
                                                                                                        lineHeight: '1.1',
                                                                                                        verticalAlign: 'top',
                                                                                                        wordWrap: 'break-word'
                                                                                                    }}
                                                                                                    dangerouslySetInnerHTML={{
                                                                                                        __html: encabezado?.centro || '<em style="color:#999">Columna centro vacía</em>'
                                                                                                    }} />

                                                                                                    {/* Columna Derecha - 30% */}
                                                                                                    <td style={{
                                                                                                        width: '30%',
                                                                                                        padding: '2px',
                                                                                                        textAlign: 'right',
                                                                                                        fontSize: '10px',
                                                                                                        lineHeight: '1.1',
                                                                                                        verticalAlign: 'top',
                                                                                                        wordWrap: 'break-word'
                                                                                                    }}
                                                                                                    dangerouslySetInnerHTML={{
                                                                                                        __html: encabezado?.derecha || '<em style="color:#999">Columna derecha vacía</em>'
                                                                                                    }} />
                                                                                                </tr>
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                    <p className="text-center text-muted mt-2 mb-0" style={{ fontSize: '11px' }}>
                                                                                        <i className="fas fa-info-circle mr-1"></i>
                                                                                        Esta vista previa simula el ancho real del documento impreso (~180mm)
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="row align-items-center mt-3">
                                                                    <div className="col-md-7 mb-3 mb-md-0">
                                                                        <div
                                                                            className="rounded px-3 py-2 mb-0"
                                                                            style={{
                                                                                border: '1px solid rgba(23, 162, 184, 0.45)',
                                                                                backgroundColor: '#f8fcfd',
                                                                                color: '#0d5c6b',
                                                                            }}
                                                                        >
                                                                            <small style={{ lineHeight: 1.45 }}>
                                                                                <i className="fas fa-user-md mr-1" aria-hidden="true"></i>
                                                                                <strong>Para profesionales:</strong>{' '}
                                                                                Usa los botones del editor (negrita, cursiva, tamaños) para formatear texto. «Insertar imagen» añade logos u otros recursos.
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-5 text-md-right">
                                                                        <button type="submit" className="btn btn-primary">
                                                                            <i className="fas fa-save mr-2"></i>
                                                                            {encabezadoExiste ? 'Actualizar' : 'Guardar'} Encabezado&nbsp;
                                                                            {loadingEncabezado && (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    )}

                                                    {activeTab === 'perfil' && (
                                                        <div className="tab-pane active config-perfil-pane">
                                                            <Perfil2 toastMsg={handleToastMsg} />
                                                        </div>
                                                    )}

                                                    {activeTab === 'firma' && (
                                                        <div className="tab-pane active">
                                                            <style>{`
                                                                .firma-tab-container {
                                                                    max-width: 960px;
                                                                }
                                                                .firma-section-card {
                                                                    border: 1px solid #eef0f2;
                                                                    border-radius: 12px;
                                                                    background: #fff;
                                                                    transition: box-shadow 0.2s ease;
                                                                }
                                                                .firma-section-card:hover {
                                                                    box-shadow: 0 2px 12px rgba(23,162,184,0.08);
                                                                }
                                                                .firma-section-header {
                                                                    background: #fafbfc;
                                                                    border-bottom: 1px solid #eef0f2;
                                                                    border-radius: 12px 12px 0 0;
                                                                    padding: 14px 18px;
                                                                    font-weight: 600;
                                                                    font-size: 0.95rem;
                                                                    color: #325e68;
                                                                    display: flex;
                                                                    align-items: center;
                                                                    gap: 8px;
                                                                }
                                                                .firma-section-body {
                                                                    padding: 20px;
                                                                }
                                                                .firma-modo-toggle {
                                                                    display: flex;
                                                                    gap: 0;
                                                                    border-radius: 10px;
                                                                    overflow: hidden;
                                                                    border: 1px solid #dee2e6;
                                                                    width: fit-content;
                                                                }
                                                                .firma-modo-btn {
                                                                    padding: 8px 20px;
                                                                    border: none;
                                                                    background: #f8f9fa;
                                                                    color: #495057;
                                                                    font-size: 0.875rem;
                                                                    font-weight: 500;
                                                                    cursor: pointer;
                                                                    transition: all 0.15s ease;
                                                                    display: flex;
                                                                    align-items: center;
                                                                    gap: 6px;
                                                                }
                                                                .firma-modo-btn:hover {
                                                                    background: #e9ecef;
                                                                }
                                                                .firma-modo-btn.activo {
                                                                    background: #17a2b8;
                                                                    color: #fff;
                                                                    font-weight: 600;
                                                                }
                                                                .firma-canvas-wrapper {
                                                                    border: 2px dashed #dee2e6;
                                                                    border-radius: 10px;
                                                                    background: #fdfdfe;
                                                                    padding: 12px;
                                                                    display: flex;
                                                                    flex-direction: column;
                                                                    align-items: center;
                                                                    transition: border-color 0.2s ease;
                                                                }
                                                                .firma-canvas-wrapper:hover {
                                                                    border-color: #17a2b8;
                                                                }
                                                                .firma-upload-zone {
                                                                    border: 2px dashed #dee2e6;
                                                                    border-radius: 10px;
                                                                    background: #fdfdfe;
                                                                    padding: 30px 20px;
                                                                    text-align: center;
                                                                    cursor: pointer;
                                                                    transition: all 0.2s ease;
                                                                    min-height: 160px;
                                                                    display: flex;
                                                                    flex-direction: column;
                                                                    align-items: center;
                                                                    justify-content: center;
                                                                }
                                                                .firma-upload-zone:hover {
                                                                    border-color: #17a2b8;
                                                                    background: #f0fafb;
                                                                }
                                                                .firma-preview-box {
                                                                    border-radius: 8px;
                                                                    padding: 15px 20px;
                                                                    background: #fafbfc;
                                                                    display: flex;
                                                                    align-items: center;
                                                                    justify-content: space-between;
                                                                    gap: 15px;
                                                                }
                                                                .firma-preview-box img {
                                                                    max-width: 180px;
                                                                    max-height: 80px;
                                                                    object-fit: contain;
                                                                }
                                                                .firma-preview-text {
                                                                    white-space: pre-line;
                                                                    font-size: 0.75rem;
                                                                    color: #495057;
                                                                    line-height: 1.6;
                                                                    text-align: left;
                                                                }
                                                                .firma-textarea {
                                                                    border-radius: 10px;
                                                                    border: 1px solid #dee2e6;
                                                                    resize: vertical;
                                                                    min-height: 130px;
                                                                    font-size: 0.8125rem;
                                                                    line-height: 1.6;
                                                                    padding: 12px 14px;
                                                                }
                                                                .firma-textarea:focus {
                                                                    border-color: #17a2b8;
                                                                    box-shadow: 0 0 0 2px rgba(23,162,184,0.15);
                                                                    outline: none;
                                                                }
                                                                .firma-guardar-btn {
                                                                    background: linear-gradient(135deg, #17a2b8, #138496);
                                                                    border: none;
                                                                    color: #fff;
                                                                    padding: 10px 32px;
                                                                    border-radius: 10px;
                                                                    font-weight: 600;
                                                                    font-size: 0.9375rem;
                                                                    transition: all 0.2s ease;
                                                                }
                                                                .firma-guardar-btn:hover:not(:disabled) {
                                                                    background: linear-gradient(135deg, #138496, #117a8b);
                                                                    transform: translateY(-1px);
                                                                    box-shadow: 0 4px 12px rgba(23,162,184,0.3);
                                                                }
                                                                .firma-guardar-btn:disabled {
                                                                    opacity: 0.7;
                                                                    cursor: not-allowed;
                                                                }
                                                                .firma-success-msg {
                                                                    color: #28a745;
                                                                    font-weight: 500;
                                                                    font-size: 0.875rem;
                                                                    animation: firmaFadeIn 0.3s ease;
                                                                }
                                                                @keyframes firmaFadeIn {
                                                                    from { opacity: 0; transform: translateY(-4px); }
                                                                    to { opacity: 1; transform: translateY(0); }
                                                                }
                                                            `}</style>

                                                            <div className="firma-tab-container">
                                                                <div className="row">
                                                                    {/* ─── SECCIÓN 1: Imagen de Firma ─── */}
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="firma-section-card h-100">
                                                                            <div className="firma-section-header">
                                                                                <i className="fas fa-pen-nib"></i>
                                                                                Imagen de Firma
                                                                            </div>
                                                                            <div className="firma-section-body">
                                                                                {/* Toggle Dibujar / Subir imagen */}
                                                                                <div className="firma-modo-toggle mb-3">
                                                                                    <button
                                                                                        type="button"
                                                                                        className={`firma-modo-btn ${modoFirma === 'dibujar' ? 'activo' : ''}`}
                                                                                        onClick={() => setModoFirma('dibujar')}
                                                                                    >
                                                                                        <i className="fas fa-pencil-alt"></i>
                                                                                        Dibujar
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className={`firma-modo-btn ${modoFirma === 'imagen' ? 'activo' : ''}`}
                                                                                        onClick={() => setModoFirma('imagen')}
                                                                                    >
                                                                                        <i className="fas fa-image"></i>
                                                                                        Subir imagen
                                                                                    </button>
                                                                                </div>

                                                                                {/* Modo Dibujar */}
                                                                                {modoFirma === 'dibujar' && (
                                                                                    <div>
                                                                                        <div className="firma-canvas-wrapper">
                                                                                            <SignatureCanvas
                                                                                                ref={firmaCanvasRef}
                                                                                                penColor="#242424"
                                                                                                canvasProps={{
                                                                                                    width: 380,
                                                                                                    height: 150,
                                                                                                    className: 'sigCanvas',
                                                                                                    style: {
                                                                                                        background: '#fff',
                                                                                                        borderRadius: '8px',
                                                                                                        cursor: 'crosshair'
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-outline-secondary btn-sm mt-2"
                                                                                            onClick={handleLimpiarFirmaCanvas}
                                                                                        >
                                                                                            <i className="fas fa-eraser mr-1"></i>
                                                                                            Borrar dibujo
                                                                                        </button>
                                                                                        <small className="text-muted d-block mt-2">
                                                                                            <i className="fas fa-info-circle mr-1"></i>
                                                                                            Dibuja tu firma con el mouse o con el dedo en dispositivos táctiles.
                                                                                        </small>
                                                                                    </div>
                                                                                )}

                                                                                {/* Modo Subir imagen */}
                                                                                {modoFirma === 'imagen' && (
                                                                                    <div>
                                                                                        <div
                                                                                            className="firma-upload-zone"
                                                                                            onClick={() => firmaFileInputRef.current && firmaFileInputRef.current.click()}
                                                                                        >
                                                                                            {firmaBlob ? (
                                                                                                <div>
                                                                                                    <img
                                                                                                        src={firmaBlob}
                                                                                                        alt="Firma cargada"
                                                                                                        style={{ maxWidth: '280px', maxHeight: '120px', marginBottom: '10px' }}
                                                                                                    />
                                                                                                    <small className="text-muted d-block">
                                                                                                        <i className="fas fa-sync-alt mr-1"></i>
                                                                                                        Haz clic para cambiar la imagen
                                                                                                    </small>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <div>
                                                                                                    <i className="fas fa-cloud-upload-alt mb-2" style={{ fontSize: '2rem', color: '#17a2b8' }}></i>
                                                                                                    <p className="mb-1 font-weight-bold" style={{ color: '#495057' }}>Haz clic para seleccionar una imagen</p>
                                                                                                    <small className="text-muted">PNG o JPG, máximo 2MB</small>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                        <input
                                                                                            type="file"
                                                                                            ref={firmaFileInputRef}
                                                                                            accept=".png,.jpg,.jpeg"
                                                                                            style={{ display: 'none' }}
                                                                                            onChange={(e) => handleSubirImagenFirma(e.target.files)}
                                                                                        />
                                                                                        {firmaBlob && (
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-outline-danger btn-sm mt-2"
                                                                                                onClick={() => setFirmaBlob('')}
                                                                                            >
                                                                                                <i className="fas fa-trash-alt mr-1"></i>
                                                                                                Quitar imagen
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* ─── SECCIÓN 2: Texto Pie de Firma ─── */}
                                                                    <div className="col-md-6 mb-3">
                                                                        <div className="firma-section-card h-100">
                                                                            <div className="firma-section-header">
                                                                                <i className="fas fa-align-left"></i>
                                                                                Texto del Pie de Firma
                                                                            </div>
                                                                            <div className="firma-section-body">
                                                                                <label className="mb-2" style={{ fontSize: '0.85rem', color: '#6c757d' }}>
                                                                                    Escribe el texto que aparecerá debajo de tu firma en las impresiones (4-5 líneas)
                                                                                </label>
                                                                                <textarea
                                                                                    className="form-control firma-textarea"
                                                                                    rows="5"
                                                                                    maxLength="500"
                                                                                    value={textoPieFirma}
                                                                                    onChange={(e) => setTextoPieFirma(e.target.value)}
                                                                                    placeholder={"Dr. Juan Carlos Pérez López\nOdontólogo General\nReg. Médico: 12345-CO\nCód. Habilitación: 67890"}
                                                                                />
                                                                                <small className="text-muted d-flex justify-content-between mt-1">
                                                                                    <span>
                                                                                        <i className="fas fa-info-circle mr-1"></i>
                                                                                        Cada línea se mostrará debajo de la firma.
                                                                                    </span>
                                                                                    <span>{textoPieFirma.length}/500</span>
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* ─── Vista Previa ─── */}
                                                                {(firmaBlob || textoPieFirma) && (
                                                                    <div className="firma-section-card mb-3">
                                                                        <div className="firma-section-header">
                                                                            <i className="fas fa-eye"></i>
                                                                            Vista Previa (Así se verá en los documentos)
                                                                        </div>
                                                                        <div className="firma-section-body">
                                                                            <div className="firma-preview-box" style={{ 
                                                                                justifyContent: 'flex-start',
                                                                                alignItems: 'center', 
                                                                                flexDirection: 'row', 
                                                                                backgroundColor: '#ffffff', 
                                                                                border: 'none', 
                                                                                padding: '10px' 
                                                                            }}>
                                                                                {textoPieFirma && (
                                                                                    <div className="firma-preview-text" style={{ textAlign: 'left', borderTop: 'none', padding: '0', margin: '0', marginRight: '40px' }}>
                                                                                        {textoPieFirma}
                                                                                    </div>
                                                                                )}
                                                                                {firmaBlob && (
                                                                                    <div>
                                                                                        <img src={firmaBlob} alt="Vista previa firma" style={{ display: 'block', margin: 0, maxWidth: '170px' }} />
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* ─── Botón Guardar ─── */}
                                                                <div className="d-flex align-items-center mt-2">
                                                                    <button
                                                                        type="button"
                                                                        className="firma-guardar-btn"
                                                                        onClick={handleGuardarFirma}
                                                                        disabled={loadingFirma}
                                                                    >
                                                                        <i className="fas fa-save mr-2"></i>
                                                                        Guardar Firma
                                                                        {loadingFirma && (
                                                                            <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                                                        )}
                                                                    </button>
                                                                    {firmaGuardadaMsg && (
                                                                        <span className="firma-success-msg ml-3">
                                                                            <i className="fas fa-check-circle mr-1"></i>
                                                                            {firmaGuardadaMsg}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                    <Footer showToast={showToast} message={toastMsg} />
                </div>
            </>
        );
    }

    return (
        <Loading />
    );
}
export default Configuracion;